function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "18pt",
  height: "18pt",
  viewBox: "0 0 18 18",
  version: 1.1
}, props), /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "stroke": "none",
    "fillRule": "nonzero",
    "fill": "#fff",
    "fillOpacity": 1
  },
  d: "M 8.109375 9 C 8.109375 10.929688 6.546875 12.492188 4.617188 12.492188 C 2.6875 12.492188 1.125 10.929688 1.125 9 C 1.125 7.070312 2.6875 5.507812 4.617188 5.507812 C 6.546875 5.507812 8.109375 7.070312 8.109375 9 Z M 16.875 9 C 16.875 10.929688 15.3125 12.492188 13.382812 12.492188 C 11.453125 12.492188 9.890625 10.929688 9.890625 9 C 9.890625 7.070312 11.453125 5.507812 13.382812 5.507812 C 15.3125 5.507812 16.875 7.070312 16.875 9 Z M 16.875 9 "
})));

export default __webpack_public_path__ + "static/media/icon_flikr.66e4beb0.svg";
export { SvgComponent as ReactComponent };